<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="承办单位" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.auditStatus" placeholder="审核状态" filterable clearable style="width: 200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.auditStatus2)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.hasTicket" placeholder="是否需要开票" filterable clearable style="width: 200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.boolean)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.addUserName" clearable placeholder="上报老师"></el-input>
        <el-date-picker v-model="queryParam.publishTime" type="daterange" range-separator="至" start-placeholder="上报开始日期" end-placeholder="上报结束日期"
                        value-format="yyyy-MM-ddTHH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="reset" type="default">重置</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="exportExcel()" type="primary" style="margin-left: 10px;">
          导出名单
        </el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="agentName" label="承办单位"></el-table-column>
        <el-table-column prop="reportNum" label="上报名单数量"></el-table-column>
        <el-table-column prop="addUserName" label="上报老师"></el-table-column>
        <el-table-column prop="publishTime" label="上报时间"></el-table-column>
        <el-table-column prop="realFee" label="实际支付报名总费用"></el-table-column>
        <el-table-column width="140" prop="" label="缴费凭证">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.srcList[0]"
              :preview-src-list="scope.row.srcList" lazy>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="hasTicket" label="是否需要开票">
          <template slot-scope="scope">
            {{$enums.boolean[scope.row.hasTicket]}}
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="公司名称"></el-table-column>
        <el-table-column prop="taxpayerNum" label="纳税人识别号"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态">
          <template slot-scope="scope">
            {{$enums.auditStatus2[scope.row.auditStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="auditUserName" label="操作人"></el-table-column>
        <el-table-column prop="auditTime" label="操作时间">
          <template slot-scope="scope">
            <span v-if="scope.row.auditTime">{{scope.row.auditTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditRemark" label="备注">
          <template slot-scope="scope">
            <span v-if="scope.row.auditRemark" style="color: #409EFF;cursor: pointer" @click="showRemark(scope.row.auditRemark)">查看</span>
          </template>
        </el-table-column>
        <el-table-column width="120" prop="fee" label="费用明细">
          <template slot-scope="scope">
            <span style="color: #409EFF;margin-right: 10px;cursor: pointer" @click="$router.push(`./Information-detail?batchId=${scope.row.batchId}&logId=${scope.row.logId}`)">查看</span>
            <div v-if="scope.row.auditStatus == 3" style="color: #409EFF;cursor: pointer" @click="downloadTemp(scope.row.logId)">下载费用明细</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="$router.push(`./Information-list?batchId=${scope.row.batchId}&logId=${scope.row.logId}`)">查看考生</el-button>
            <el-button v-if="scope.row.auditStatus == 2" size="mini" type="text" @click="save(scope.row)">审核通过</el-button>
            <el-button v-if="scope.row.auditStatus == 2" size="mini" type="text" style="color: #E91212;" @click="edit(scope.row)">审核不通过</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="导入证件照" v-if="examForm.show" :visible.sync="examForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Exam @close="onClose"></Exam>
    </el-dialog>
    <el-dialog title="备注" v-if="remarkForm.show" :visible.sync="remarkForm.show" width="500px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <div>{{remark}}</div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p>当前导出进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
    </el-dialog>
    <el-dialog title="审核不通过" v-if="editForm.show" :visible.sync="editForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Exam from './order-photoEdit'
import KtButton from '../../components/ktButton'
import Edit from './unpass-edit'

export default {
  name: 'examined-Information',
  components: { Exam, KtButton, Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId, auditStatus: 2 },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: [],
      agentList: [],
      examForm: { show: false, row: null },
      remarkForm: { show: false, row: null },
      gradeList: [],
      officeList: [],
      percent: null,
      dialogVisible: false,
      calcData:{},
      remark: ''
    }
  },
  async created () {
    await this.getPermission()
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3],batchType: 1 })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    reset () {
      this.$router.replace({ query: null })
      window.location.reload()
      // this.queryParam = JSON.parse(JSON.stringify(this.oldQueryParam))
      // this.getPage({ pageNum: 1 })
      // this.getSpecialtyList()
      // this.gradeList = []
    },
    showRemark (row) {
      this.remark = row
      this.remarkForm.show = true
    },
    async getSpecialtyList (event) {
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.dialogVisible = false
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiExamAudit.getReportPage(this.queryParam)
        for (let i in page.list) {
          let item = page.list[i]
          item.srcList = []
          if(item.voucherUrl) {
            let arry = item.voucherUrl.split(',')
            if (arry.length > 0) {
              for (let j in arry) {
                let img = arry[j]
                img = await this.$HTTP.ApiOss.signatureUrl(img, 'agent-data')
                item.srcList.push(img)
              }
            }
          }
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadIdNo (index, row) {
      if (row.trueEye == true) {
        this.$set(row, 'trueEye', false)
      } else {
        this.$set(row, 'trueEye', true)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async onClose (event) {
      try {
        this.getTaskInfo('import_official_photo')
        this.examForm.show = false
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async exportExcel (row) {
      try {
        await this.$HTTP.ApiExamAudit.exportReport(this.queryParam)
        this.getTaskInfo('export_exam_report_list')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async editPhoto (row) {
      try {
        await this.$HTTP.ApiExamOnline.autoReplacePhoto(this.queryParam)
        this.getTaskInfo('auto_replace_photo')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      // debugger
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          if (taskInfo) {
            this.dialogVisible = true
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              this.dialogVisible = false
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    async save (row) {
      try {
        let confirm = await this.$confirm('确定要通过审核吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let param = {
            isPass: 1,
            logId: row.logId
          }
          await this.$HTTP.ApiExamAudit.auditReport(param)
          this.$message({ type: 'success', message: '操作成功' })
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async downloadTemp (id) {
      let fileUrl = await this.$HTTP.ApiExamAudit.download(id)
      fileUrl = await this.$HTTP.ApiOss.signatureUrl(fileUrl, 'temp')
      this.Tool.downloadFile(fileUrl)
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms)
    },
    getPermission () { // 模拟接口 获取 权限数据集合
      let perms = this.$store.state.buttonList
      // this.$store.dispatch("SET_PERMISSION", perms)
    }
  }
}
</script>
